import {
  IAssessmentAttempt,
  IAssessmentQuestion
} from 'interfaces/assessments';

export const QUESTION_STATUSES_MAP: Record<
  IAssessmentAttempt['status'],
  { label: string; color: string }
> = {
  correct: {
    label: 'Correta',
    color: 'success'
  },
  blank: {
    label: 'Em branco',
    color: 'default'
  },
  wrong: {
    label: 'Errada',
    color: 'error'
  },
  nullified: {
    label: 'Anulada',
    color: 'success'
  },
  evaluation_started: {
    label: 'Em correção',
    color: 'warning'
  },
  pending_evaluation: {
    label: 'Aguardando correção',
    color: 'warning'
  },
  pending: {
    label: 'Pendente',
    color: 'warning'
  },
  not_evaluated: {
    label: 'Não avaliada',
    color: 'default'
  }
};
export const QUESTION_STATE_MAP: Record<
  IAssessmentQuestion['status'],
  { label: string; color: string }
> = {
  active: {
    label: 'Ativa',
    color: 'blue'
  },
  inactive: {
    label: 'Inativa',
    color: 'gray'
  },
  nullified: {
    label: 'Anulada',
    color: 'red'
  }
};

export const QUESTION_KIND_OPTIONS: {
  label: string;
  value: IAssessmentQuestion['kind'];
}[] = [
  { label: 'Objetiva', value: 'objective' },
  { label: 'Discursiva', value: 'discursive' }
];
